import { styled } from 'styled-components';
import { Button } from 'antd';

// Inline: コンテンツサイズで高さが決まる
export const Section = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

export const SectionInner = styled.div`
  width: 100%;
  margin: 0;
  padding: 40px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const MicrophoneIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: rgb(224 231 255);
  color: rgb(79 70 229);
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1a1a2e;
`;

export const Description = styled.p`
  font-size: 12px;
  color: #6b7280;
  text-align: center;
  line-height: 1.6;
`;

export const UploadButton = styled(Button)`
  min-width: 150px;
`;

export const FormatInfo = styled.p`
  font-size: 12px;
  color: #9ca3af;
`;
